import { getContextSchema } from './schemas.js';
export const SafeContext = {
    parse(unsafeContext) {
        try {
            return getContextSchema().parse(unsafeContext);
        }
        catch {
            return undefined;
        }
    },
    getSchema: getContextSchema,
};
